"use client";

import { useState } from "react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import type { Faq } from "@/lib/data/faqs";

export function AccordionItem({
  faq,
  open,
  onToggle,
  index,
}: {
  faq: Faq;
  open: boolean;
  onToggle: () => void;
  index: number;
}) {
  return (
    <article className={cn("accordion-item", open && "open")}>
      <h3 className="m-0">
        <button
          type="button"
          className="accordion-trigger"
          aria-expanded={open}
          aria-controls={`faq-panel-${index}`}
          id={`faq-trigger-${index}`}
          onClick={onToggle}
        >
          <span>{faq.question}</span>
          <span className="chev" aria-hidden="true">
            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" aria-hidden="true">
              <path d="m1 1 4.5 4.5L10 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </button>
      </h3>
      <div className="accordion-panel" id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`}>
        <div className="accordion-panel-inner">
          <p>{faq.answer}</p>
        </div>
      </div>
    </article>
  );
}

export function Accordion({ items, className }: { items: Faq[]; className?: string }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className={className}>
      {items.map((faq, index) => (
        <AccordionItem
          key={faq.question}
          faq={faq}
          index={index}
          open={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
        />
      ))}
    </div>
  );
}

export function AccordionGroup({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={className}>{children}</div>;
}